import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import * as configStepper from '../../../../../assets/config/stepper_fr.json';
import { MatStepper } from '@angular/material/stepper';
import { StepperStatusEnum } from '../../models/stepper-status-enum';
import { StepperComponentActivationService } from 'src/app/modules/signature/guards/stepper-component-activation-service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { StepperMessages } from '../../models/component-messages/stepper-messages';
import { PinValidatorService } from 'src/app/modules/signature/services/pin-validator.service';


@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class StepperComponent implements OnInit, OnDestroy {

  @Input() steps: any;
  public stepsStatus: Map<number, StepperStatusEnum> = new Map();
  public steppersConfig = configStepper.config;
  public isMobile = false;
  public validationErrorMessage: string;
  public isValid = true;
  public stepperMessages = new StepperMessages();

  constructor(
    private stepperComponentActivationService: StepperComponentActivationService,
    private breakpointObserver: BreakpointObserver,
    public pinValidator: PinValidatorService
  ) {
    const layoutChanges = this.breakpointObserver.observe(['(max-width: 768px)']);
    layoutChanges.subscribe(result => {
      this.initStepsStatus();
      this.isMobile = result.matches;
    });
  }

  public ngOnDestroy(): void {
  }

  public ngOnInit() {
    this.initStepsStatus();
  }

  public goBack(stepper: MatStepper) {
    const currentIndex = stepper.selectedIndex;
    const newIndex = stepper.selectedIndex - 1;
    this.stepsStatus.set(currentIndex, StepperStatusEnum.EMPTY);
    this.stepsStatus.set(newIndex, StepperStatusEnum.VISIT);
    this.isValid = true;
    stepper.previous();
  }

  public goForward(stepper: MatStepper) {
    const currentIndex = stepper.selectedIndex;
    const newIndex = stepper.selectedIndex + 1;
    this.stepsStatus.set(currentIndex, StepperStatusEnum.VISIT);
    if (this.stepsStatus.get(newIndex) === StepperStatusEnum.EMPTY) {
      this.stepsStatus.set(newIndex, StepperStatusEnum.CREATE);
    } else {
      this.stepsStatus.set(currentIndex, StepperStatusEnum.VISIT);
    }
    this.stepperComponentActivationService.canActivate(this.steppersConfig[newIndex].component)
      .subscribe(stepperCanActivated => {
        if (stepperCanActivated.canActivate) {
          this.isValid = true;
          stepper.next();
        } else {
          this.isValid = false;
          this.validationErrorMessage = stepperCanActivated.reason;
        }
      });
  }

  private initStepsStatus() {
    this.steppersConfig.forEach((currentValue, index) => {
      this.stepsStatus.set(index, StepperStatusEnum[currentValue.status]);
    });
  }
}
